function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import classNames from 'classnames';
import dateFormat from 'dateformat';
import NoContextMenu from '../no-context-menu/no-context-menu.js';
import { numberWithCommas, parseDate } from '../../utils/web/index.js';
import Input from '../input/input.js';
import './table2.scss';

class Table2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      masterChecked: false,
      sortBy: '',
      sortDirection: 'asc',
      hasCheckedRows: false
    };
    this.rowRefs = [];
    this.lastRowClicked = null;
    this.lastRowChecked = null;
    this.sortedRows = [];
  }

  handleMasterCheckboxClicked() {
    var {
      masterChecked
    } = this.state;

    for (var rowRef of this.rowRefs) {
      rowRef.ref.checked = !masterChecked;
      rowRef.ref.setState({
        checked: !masterChecked
      });
    }

    this.setState({
      masterChecked: !masterChecked
    });
  }

  handleHeaderClick(header) {
    var {
      sortBy,
      sortDirection
    } = this.state;
    var key = header.key;

    if (key === sortBy) {
      this.setState({
        sortDirection: sortDirection === 'asc' ? 'desc' : 'asc'
      });
    } else {
      this.setState({
        sortBy: key,
        sortDirection: 'asc'
      });
    }
  }

  unhighlightAllRows() {
    for (var rowRef of this.rowRefs) {
      rowRef.ref.setState({
        highlighted: false
      });
    }
  }

  handleRowClicked(rowId) {
    this.lastRowClicked = rowId; // console.log(rowId);
  }

  shiftHighlightRows(toRowValue) {
    var {
      rowRefs,
      sortedRows
    } = this;
    var mainKey = this.getMainKey();
    var fromIndex = sortedRows.findIndex(row => row[mainKey] === this.lastRowClicked);
    var toIndex = sortedRows.findIndex(row => row[mainKey] === toRowValue);

    if (fromIndex >= 0 && toIndex >= 0 && fromIndex !== toIndex) {
      this.unhighlightAllRows();

      if (fromIndex > toIndex) {
        [fromIndex, toIndex] = [toIndex, fromIndex];
      }

      for (var i = fromIndex; i <= toIndex; i++) {
        var rowId = sortedRows[i][mainKey];
        var rowRef = rowRefs.find(ref => ref.rowId === rowId);

        if (rowRef) {
          rowRef.ref.setState({
            highlighted: true
          });
        }
      }
    }

    if (document.selection && document.selection.empty) {
      document.selection.empty();
    } else if (window.getSelection) {
      var sel = window.getSelection();
      sel.removeAllRanges();
    }
  }

  handleRowCheckboxClicked(rowId) {
    var {
      hasCheckedRows
    } = this.state;
    this.lastRowChecked = rowId;
    var someRowsChecked = false;

    for (var rowRef of this.rowRefs) {
      if (rowRef.ref.checked) {
        someRowsChecked = true;
        break;
      }
    }

    if (someRowsChecked !== hasCheckedRows) {
      this.setState({
        hasCheckedRows: someRowsChecked
      });
    }
  }

  shiftCheckboxRows(toRowValue) {
    var {
      rowRefs,
      sortedRows
    } = this;
    var mainKey = this.getMainKey();
    var fromIndex = sortedRows.findIndex(row => row[mainKey] === this.lastRowChecked);
    var toIndex = sortedRows.findIndex(row => row[mainKey] === toRowValue);

    if (fromIndex >= 0 && toIndex >= 0 && fromIndex !== toIndex) {
      var changeCheckbox = index => {
        var rowId = sortedRows[index][mainKey];
        var rowRef = rowRefs.find(ref => ref.rowId === rowId);

        if (rowRef) {
          var newChecked = !rowRef.ref.state.checked;
          rowRef.ref.checked = newChecked;
          rowRef.ref.setState({
            checked: newChecked
          });
        }
      };

      if (fromIndex > toIndex) {
        for (var i = fromIndex - 1; i >= toIndex; i--) {
          changeCheckbox(i);
        }
      } else {
        for (var i = fromIndex + 1; i <= toIndex; i++) {
          changeCheckbox(i);
        }
      }
    }
  }

  handleCheckedActionClick(event, func) {
    var checkedRows = this.rowRefs.filter(rowRef => rowRef.ref.checked).map(rowRef => rowRef.rowId);
    var checkedObjects = [];
    var mainKey = this.getMainKey();

    for (var [i, row] of this.sortedRows.entries()) {
      var rowId = this.getMainKeyValue(mainKey, i);

      if (checkedRows.includes(rowId)) {
        checkedObjects.push(row);
      }
    }

    func(checkedObjects, event);
  }

  getSortedRows() {
    var {
      headers,
      rows
    } = this.props;
    var {
      sortBy,
      sortDirection
    } = this.state;

    if (!sortBy) {
      return rows;
    }

    var header = headers.find(h => h.key === sortBy);
    rows = [...rows];

    if (header.dataType === 'string') {
      rows.sort((a, b) => (a[sortBy].value == null ? a[sortBy] : a[sortBy].value).localeCompare(b[sortBy].value == null ? b[sortBy] : b[sortBy].value));
    } else if (header.dataType === 'date') {
      rows.sort((a, b) => parseDate(a[sortBy].value == null ? a[sortBy] : a[sortBy].value) - parseDate(b[sortBy].value == null ? b[sortBy] : b[sortBy].value));
    } else if (header.dataType === 'number') {
      rows.sort((a, b) => (a[sortBy].value == null ? a[sortBy] : a[sortBy].value) - (b[sortBy].value == null ? b[sortBy] : b[sortBy].value));
    }

    if (sortDirection === 'desc') {
      rows.reverse();
    }

    return rows;
  }

  getMainKey() {
    var {
      headers,
      mainKey = null,
      rows
    } = this.props;

    if (!mainKey) {
      if (rows[0]?.rowId != null) {
        mainKey = 'rowId';
      } else {
        mainKey = headers[0].key;
      }
    }

    return mainKey;
  }

  getMainKeyValue(mainKey, i) {
    var value = this.sortedRows[i]?.[mainKey];
    return value == null ? null : value;
  }

  render() {
    var {
      alternateColors = false,
      cellActions = {},
      checkedActions,
      className,
      clickGroups,
      compressed = false,
      customColors = false,
      footerRows = [],
      headerGroups = [],
      headers,
      includeCheckbox = false,
      maxHeight = null,
      showRowCount = true,
      showClickGroupsColumn = true,
      showNullValues = false
    } = this.props;
    var {
      hasCheckedRows,
      masterChecked
    } = this.state;
    var hasClickGroups = !!clickGroups?.length;
    var ContextMenu = hasClickGroups ? NoContextMenu : React.Fragment;
    var widths = headers.map(header => header.width || 100);
    var tableWidth = widths.reduce((acc, width) => acc + width, 0) + 1;
    var gridTemplateColumns = widths.join('px ') + 'px';

    if (includeCheckbox) {
      tableWidth += 30;
      gridTemplateColumns = '30px ' + gridTemplateColumns;
    }

    if (hasClickGroups && showClickGroupsColumn) {
      tableWidth += 32;
      gridTemplateColumns += ' 32px';
    }

    var hasHeaderGroups = !!headerGroups?.length;
    var headerGroupWidths = [];

    if (hasHeaderGroups) {
      headerGroupWidths = headerGroups.map((group, i) => {
        var groupWidth = group.width || 0;

        if (groupWidth > 0) {
          return groupWidth;
        }

        for (var key of group.headers) {
          var header = headers.find(h => h.key === key);

          if (header) {
            groupWidth += header.width || 100;
          }
        }

        if (hasClickGroups && showClickGroupsColumn && i == headerGroups.length - 1) {
          groupWidth += 32;
        }

        group.width = groupWidth;
        return groupWidth;
      });
    }

    var mainKey = this.getMainKey();
    this.sortedRows = this.getSortedRows(); // console.log(this.sortedRows);

    while (this.sortedRows.length < this.rowRefs.length) {
      this.rowRefs.pop();
    }

    return /*#__PURE__*/React.createElement("div", {
      className: classNames('myTable2MasterContainer', className)
    }, /*#__PURE__*/React.createElement("div", {
      className: "myTable2Container"
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames('myTable2', {
        hasHeaderGroups,
        defaultColors: !customColors,
        compressed
      }),
      style: {
        width: tableWidth,
        maxHeight
      }
    }, hasHeaderGroups && /*#__PURE__*/React.createElement("div", {
      className: "headerRow",
      style: {
        gridTemplateColumns: headerGroupWidths.join('px ') + 'px'
      }
    }, headerGroups.map(group => /*#__PURE__*/React.createElement("div", {
      className: "headerCell",
      key: group.name
    }, group.name))), /*#__PURE__*/React.createElement("div", {
      className: "headerRow",
      style: {
        gridTemplateColumns
      }
    }, includeCheckbox && /*#__PURE__*/React.createElement("div", {
      className: "headerCell",
      keyid: "checkbox"
    }, /*#__PURE__*/React.createElement("input", {
      className: "headerCellCheckbox",
      type: "checkbox",
      checked: masterChecked,
      onChange: () => this.handleMasterCheckboxClicked()
    })), headers.map(header => header.dataType === 'switch' ? /*#__PURE__*/React.createElement("div", {
      className: "headerCell",
      key: header.key,
      keyid: header.key
    }, header.label) : /*#__PURE__*/React.createElement("div", {
      className: "headerCell",
      key: header.key,
      keyid: header.key,
      onClick: () => this.handleHeaderClick(header)
    }, header.label)), hasClickGroups && showClickGroupsColumn && /*#__PURE__*/React.createElement("div", {
      className: "headerCell",
      keyid: "clickGroups"
    })), /*#__PURE__*/React.createElement("div", {
      className: "rowsContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rowsGridContainer",
      style: {
        gridTemplateColumns
      }
    }, this.sortedRows.map((row, i) => /*#__PURE__*/React.createElement(Table2Row, {
      key: this.getMainKeyValue(mainKey, i),
      cellActions: cellActions,
      clickGroups: clickGroups,
      darkRow: alternateColors && i % 2,
      headers: headers,
      includeCheckbox: includeCheckbox,
      row: row,
      ref: ref => {
        var rowId = this.getMainKeyValue(mainKey, i);

        if (rowId != null) {
          this.rowRefs[i] = {
            rowId,
            ref
          };
        }
      },
      rowClicked: () => this.handleRowClicked(this.getMainKeyValue(mainKey, i)),
      checkboxClicked: () => this.handleRowCheckboxClicked(this.getMainKeyValue(mainKey, i)),
      unhighlightAllRows: () => this.unhighlightAllRows(),
      shiftHighlightRow: () => this.shiftHighlightRows(this.getMainKeyValue(mainKey, i)),
      shiftCheckboxRow: () => this.shiftCheckboxRows(this.getMainKeyValue(mainKey, i)),
      showClickGroupsColumn: showClickGroupsColumn,
      showNullValues: showNullValues
    })), footerRows.map((row, i) => /*#__PURE__*/React.createElement(Table2Row, {
      key: i,
      clickGroups: clickGroups,
      footerRow: true,
      headers: headers,
      row: row
    })))))), /*#__PURE__*/React.createElement("div", {
      className: "tableExtras"
    }, showRowCount && /*#__PURE__*/React.createElement("span", {
      className: "rowCount"
    }, "Rows: ", this.sortedRows.length), hasCheckedRows && !!checkedActions?.length && checkedActions.map(action => /*#__PURE__*/React.createElement(Input, {
      type: "button",
      label: action.label,
      onClick: event => this.handleCheckedActionClick(event, action.onClick),
      key: action.label
    }))));
  }

}

class Table2Row extends Component {
  checked = false;
  state = {
    checked: false,
    highlighted: false
  };

  handleRowClicked(event) {
    var {
      footerRow,
      rowClicked,
      shiftHighlightRow,
      unhighlightAllRows
    } = this.props;
    var {
      highlighted
    } = this.state;

    if (footerRow) {
      return;
    }

    if (event.shiftKey) {
      return shiftHighlightRow();
    }

    rowClicked(); // console.log(event); // shiftKey

    if (!event.metaKey && !event.ctrlKey) {
      unhighlightAllRows();
    }

    this.setState({
      highlighted: !highlighted
    });
  }

  handleCheckboxClicked(event) {
    var {
      checkboxClicked,
      footerRow,
      shiftCheckboxRow
    } = this.props;
    var {
      checked
    } = this.state;

    if (footerRow) {
      return;
    }

    if (event.shiftKey) {
      shiftCheckboxRow();
      checkboxClicked();
      return;
    }

    this.checked = !checked;
    this.setState({
      checked: !checked
    });
    checkboxClicked();
  }

  getCellToUse(header, row) {
    var key = header.key;
    var cell = row[key];

    if (['className', 'noContextObject'].includes(key)) {
      // special fields that aren't values
      return cell;
    }

    if (typeof cell === 'undefined') {
      return cell;
    }

    if (typeof cell !== 'object' || cell instanceof Date) {
      cell = {
        value: cell
      };
    } else if (cell === null) {
      cell = {
        value: null
      };
    } else {
      cell = { ...cell
      };
    }

    if (cell.value instanceof Date) {
      cell.value = dateFormat(cell.value, header.dateFormat || 'ddd mmm d, yyyy');
    }

    if (header.className) {
      var headerClass = header.className;

      if (typeof headerClass === 'function') {
        headerClass = headerClass({
          header,
          row,
          cell
        });
      }

      cell.className = classNames(cell.className, headerClass);
    }

    if (header.format === 'money' || cell.format === 'money') {
      cell.className = classNames(cell.className, 'moneyCell');

      if (cell.value == null) {
        cell.value = '';
      } else if (typeof cell.value !== 'number') {
        cell.value = cell.value.toString();
      } else if (cell.value === 0) {
        cell.value = /*#__PURE__*/React.createElement("span", {
          style: {
            paddingRight: '8px'
          }
        }, "-");
      } else {
        if (cell.value < 0) {
          cell.value = `(${numberWithCommas(Math.abs(cell.value), 2)})`;
        } else {
          cell.value = numberWithCommas(cell.value, 2);
        }
      }
    } else if (header.format === 'percent' || cell.format === 'percent') {
      cell.className = classNames(cell.className, 'centered');

      if (cell.value == null) {
        cell.value = '';
      } else if (typeof cell.value !== 'number') {
        cell.value = cell.value.toString();
      } else if (cell.value >= 0) {
        cell.value = '+' + numberWithCommas(cell.value, 1) + '%';
      } else {
        cell.value = numberWithCommas(cell.value, 1) + '%';
      }
    } else if (header.format === 'simplePercent' || cell.format === 'simplePercent') {
      cell.className = classNames(cell.className, 'centered');

      if (cell.value == null) {
        cell.value = '';
      } else if (typeof cell.value !== 'number') {
        cell.value = cell.value.toString();
      } else {
        cell.value = numberWithCommas(cell.value * 100) + '%';
      }
    }

    return cell;
  }

  getCellActions(header) {
    var {
      cellActions,
      footerRow,
      row
    } = this.props;

    if (footerRow) {
      return {};
    }

    var actions = { ...cellActions,
      ...header.cellActions
    };
    Object.entries(actions).forEach(([type, action]) => {
      if (typeof action === 'function') {
        actions[type] = event => action({
          event,
          header,
          row
        });
      } else {
        actions[type] = null;
      }
    });
    return actions;
  }

  render() {
    var {
      clickGroups,
      darkRow,
      footerRow = false,
      headers,
      includeCheckbox,
      row,
      showClickGroupsColumn = true,
      showNullValues = false
    } = this.props;
    var {
      checked,
      highlighted
    } = this.state;
    var hasClickGroups = !!clickGroups?.length;
    var ContextMenu = !footerRow && hasClickGroups ? NoContextMenu : React.Fragment;
    var contextMenuProps = !footerRow && hasClickGroups ? {
      groups: clickGroups,
      object: row.noContextObject || row
    } : {};
    return /*#__PURE__*/React.createElement(ContextMenu, contextMenuProps, /*#__PURE__*/React.createElement("div", {
      className: classNames('tableRow', {
        highlighted,
        darkRow,
        footerRow
      }, row.className),
      onClick: event => this.handleRowClicked(event)
    }, includeCheckbox && !footerRow && /*#__PURE__*/React.createElement("div", {
      className: "tableCell tableCellCheckboxContainer",
      onClick: event => this.handleCheckboxClicked(event),
      keyid: "checkbox"
    }, /*#__PURE__*/React.createElement("input", {
      className: "tableCellCheckbox",
      type: "checkbox",
      checked: checked,
      onClick: event => this.handleCheckboxClicked(event),
      onChange: () => {}
    })), headers.map(header => {
      var cell = this.getCellToUse(header, row);

      if (typeof cell === 'undefined') {
        return /*#__PURE__*/React.createElement("div", {
          className: "tableCell undefinedCell",
          key: header.key,
          keyid: header.key
        });
      }

      return header.dataType === 'switch' ? /*#__PURE__*/React.createElement("div", {
        className: classNames('tableCell', cell.className),
        key: header.key,
        keyid: header.key
      }, /*#__PURE__*/React.createElement(Input, {
        type: "switch",
        value: cell.value,
        onChange: newValue => header.onChange(newValue, row)
      })) : /*#__PURE__*/React.createElement("div", _extends({
        className: classNames('tableCell', cell.className, {
          nullValue: cell.value === null
        }),
        key: header.key,
        keyid: header.key
      }, this.getCellActions(header)), cell.value === null && showNullValues ? 'null' : cell.value);
    }), hasClickGroups && showClickGroupsColumn && (footerRow ? /*#__PURE__*/React.createElement("div", {
      className: "tableCell tableCellClickMenu undefinedCell",
      keyid: "clickGroups"
    }) : /*#__PURE__*/React.createElement(NoContextMenu, {
      actionType: "click",
      groups: clickGroups,
      object: row.noContextObject || row,
      alwaysCentered: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "tableCell tableCellClickMenu",
      keyid: "clickGroups"
    }, "\u2022\u2022\u2022")))));
  }

}

export default Table2;